/**
 * Bridge so non-view code (toasts, background handlers) can trigger app-level
 * campaign navigation. The App registers its tab/URL-aware select handler here.
 */

let navigateHandler = null;
let openInNewTabHandler = null;
let queuedMissionFocus = null;

export function setNavigateToCampaignHandler(handler) {
  navigateHandler = handler;
}

export function setOpenCampaignInNewTabHandler(handler) {
  openInNewTabHandler = handler;
}

/**
 * Navigate to a campaign. Accepts a sprint object (metadata is enough).
 * Options are forwarded to the app's select handler (e.g. { missionId } to
 * focus/center a specific mission card after navigation).
 * Returns false if no handler is registered yet.
 */
export function navigateToCampaign(sprint, options = {}) {
  if (!navigateHandler || !sprint) return false;
  navigateHandler(sprint, options);
  return true;
}

/**
 * Open a campaign in a new in-app tab. Options match navigateToCampaign
 * (e.g. { missionId } to focus that mission on the new tab).
 * Returns false if no handler is registered yet.
 */
export function openCampaignInNewTab(sprint, options = {}) {
  if (!openInNewTabHandler || !sprint) return false;
  openInNewTabHandler(sprint, options);
  return true;
}

/** Remember a mission to center once the new campaign tab finishes switching. */
export function queueCampaignMissionFocus(campaignId, missionId) {
  queuedMissionFocus = campaignId && missionId ? { campaignId, missionId } : null;
}

export function takeCampaignMissionFocus(campaignId) {
  if (!queuedMissionFocus || queuedMissionFocus.campaignId !== campaignId) return null;
  const missionId = queuedMissionFocus.missionId;
  queuedMissionFocus = null;
  return missionId;
}
